import React  , { Component } from 'react';
import { Link } from 'react-router-dom'
import LazyLoad from 'react-lazyload';

import {  HomeSlider,
          HomeDeals,
          VideoSliderItem2,
          PostSliderItem,
          HomeTitle,
          ResponsiveYouTubeIframe,
          ActivaImg        } from '../../Components/UI/UI';

import SimpleSlider from '../../Components/SimpleSlider/SimpleSlider';


import { agentsArr } from "../../Data/Data";
import { getWeather, isMobile } from "../../Utility/Utility";
import Menu from '../../Components/Menu/Menu'
import Footer from '../../Components/Footer/Footer'

import "../innerPage.css"
import "./GeneralPage.css"



const sliderSettings = {
  dots: false,
  autoplay: true,
  // lazyLoad: 'ondemand',
  infinite: true,
  lazyLoad: "ondemand",
  cssEase: 'linear',
  slidesToShow: 3,
  slidesToScroll: 3,

  responsive: [
    {
      breakpoint: 1000,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },

    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
  
};

class GeneralPage extends Component {

  state = {
   
    telAvivWeather : 0,
    waterTemp : 0,
    jerusalemWeather : 0,
    vidId: "FvAWuLQEOJw"

  }

  componentDidMount () {

    getWeather((Weather)=>{
    
      this.setState({
        telAvivWeather : Weather.telAvivWeather,
        waterTemp : Weather.water_temp,
        jerusalemWeather : Weather.jerusalemWeather,
      })

      
    });
    

     
  }
  


  render(){
    // get all posts 
    const  posts = [ ...agentsArr ] ;

    // get non video posts and culinary posts
    const generalPosts = posts.filter((o , i )=>{
       return (o.ctg === 'general' ) && o.isDouble === false;
    })

    // const thingsToDoPosts = [ ...posts ];


    const postsHtml = generalPosts.map( (o,i) => {
        // console.log('o' , o);
        let cssClass="";
        let html ="";
        if ( i % 4 === 0 ) {
          cssClass =" first";
        }
        let url = null;
        let component = null;
        
        if (o.isVid === true) {
         
          url  = "/Posts/Videos/" + o.ctg  + '/' + o.id;
          component = <VideoSliderItem2  
                        key={i}
                        title={o.title}
                        desc={""}
                        img= {o.img}
                        link={url}
                        cssClass={cssClass}
                        click={() => this.setState({vidId: o.vidId})} />
        }else {
          // url = "/Posts/" + o.id ;
          url  = "/Posts/" + o.ctg  + '/' + o.id;
          component = <PostSliderItem  
                          key={i}
                          title={o.title}
                          desc={""}
                          img= {o.img}
                          link={url}
                          cssClass={cssClass} />
        }

        return component;
        
    });

    return(
      <div className="inner-page align-center page-general">
        <Menu/>
        <HomeSlider waterTemp={this.state.waterTemp} telAvivWeather={this.state.telAvivWeather} jerusalemWeather={this.state.jerusalemWeather} />
        
        <section className="live-shows-section">

        <LazyLoad height={200} once offset={100}>
          <section  className="home-section home-section-padding weather-section" id="expore-jerusalem">
            <div className="container">
              <HomeTitle>
              Things To Do
              </HomeTitle>
              { isMobile() && this.state.imageState4 ? <ActivaImg src={"PostCarousel/video_mob/activa-img-north.jpg"} click={this.playVideo4}/> : <ResponsiveYouTubeIframe vidId={this.state.vidId} />}
              <div className="clear"></div>
              
              <div className="video-slider-wrapper">
                <SimpleSlider settings={sliderSettings}>
                  {postsHtml}
                </SimpleSlider>
              </div>

              <div className="clear"></div>
            </div>
          </section>
        </LazyLoad>
            {/* <HomeDeals /> */}
        </section>
        <Footer />
      </div>
    )
  }

}



export default GeneralPage


// WEBPACK FOOTER //
// ./src/Pages/GeneralPage/GeneralPage.js